export default __webpack_public_path__ + "static/media/minus.39b382bb.svg";